import React from 'react';
import { 
  HeartHandshake, 
  ShieldCheck, 
  CheckCircle2, 
  ExternalLink,
  Info
} from 'lucide-react';

export const MedicareShieldPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-950 text-emerald-300 text-xs font-bold border border-emerald-800">
          <HeartHandshake className="w-3.5 h-3.5" />
          <span>SERVICES AUSTRALIA MEDICARE DEFENCE</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Medicare Card Compromise & IRN Audit</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Audit your 10-digit Medicare card number, rotate your Individual Reference Number (IRN), and inspect health claims history.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-6 shadow-xl text-xs">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-5 rounded-2xl bg-slate-950 border border-slate-800 space-y-2">
            <h4 className="font-bold text-white text-sm">1. Replace Card on myGov</h4>
            <p className="text-slate-400 leading-relaxed">
              Replacing a compromised Medicare card issues a brand new 10-digit number that invalidates leaked scans on the Document Verification Service.
            </p>
          </div>
          <div className="p-5 rounded-2xl bg-slate-950 border border-slate-800 space-y-2">
            <h4 className="font-bold text-white text-sm">2. Audit Medicare Claims History</h4>
            <p className="text-slate-400 leading-relaxed">
              Log into myGov &rarr; Medicare &rarr; History to ensure no unauthorized bulk-billing or PBS medication claims have been submitted under your name.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
